<template>
	<!--<div class="input__container">
    <label class="input__label" :class="{'input__label--disabled': isDisabled}">
      <input
        @change="getValue($event.target.checked)"
        type="checkbox"
        class="input__checkbox"
        :checked="isChecked"
        :disabled="isDisabled"
      />
      <span class="input__icon"></span>
      <span class="input__title">{{label}}</span>
    </label>
  </div>-->
	<label
		:class="[
			'checkbox',
			cartStyling ? 'checkbox--cart' : '',
			lightTheme ? 'checkbox--lightTheme' : '',
			small ? 'checkbox--small' : '',
			isDisabled ? 'checkbox--disabled' : ''
		]"
	>
		<input
			v-if="!stringId == ''"
			class="checkbox__input"
			:data-id="stringId"
			type="checkbox"
			@change="
				getValue($event.target.checked, $event.target.getAttribute('data-id'))
			"
			:checked="isChecked"
			:disabled="isDisabled"
		/>
		<input
			v-else
			class="checkbox__input"
			:data-id="dataId"
			type="checkbox"
			@change="
				getValue($event.target.checked, $event.target.getAttribute('data-id'))
			"
			:checked="isChecked"
			:disabled="isDisabled"
		/>
		<span class="checkbox__box">
			<span>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
			</span>
		</span>
		<span class="checkbox__title" v-html="label"></span>
	</label>
</template>

<script>
export default {
	name: 'Checkbox',
	props: {
		dataId: {
			type: Number,
			default: 0
		},
		stringId: {
			type: [Number, String],
			default: ''
		},
		checkboxValue: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		small: {
			type: Boolean,
			default: false
		},
		isChecked: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		cartStyling: {
			type: Boolean,
			default: false
		},
		lightTheme: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		getValue(val, id) {
			this.$emit('check-input', val, id)
		}
	}
}
</script>

<style scoped lang="scss">
.checkbox {
	display: flex;
	position: relative;
	align-items: center;
	&:hover {
		cursor: pointer;
	}
	/*justify-content: space-between;*/
	//width: 100%;
	&--disabled {
		// opacity: 0.5;
		pointer-events: none;
		&:hover {
			cursor: auto;
		}
	}
	&__input {
		position: absolute;
		visibility: hidden;
		/*&:checked ~ .input__icon:after {
      transform: scale(1);
    }*/
		+ span > span {
			margin-top: 2px;
			display: none;
		}
		&:checked {
			+ span {
				background-color: $colorPrimary7;
				border: 1px solid $colorPrimary7;
			}
			+ span > span {
				display: block;
			}
			&:disabled {
				+ span > span {
					display: block;
				}
			}
		}
		&:disabled {
			+ span {
				background-color: $colorPrimary1;
			}
			+ span > span {
				display: none;
			}
		}
	}
	&__box {
		display: inline-block;
		min-width: 18px;
		min-height: 18px;
		box-sizing: border-box;
		border: 1px solid $colorPrimary3;
		box-shadow: inset 0 1px 3px 0 rgba(148, 158, 177, 0.1);
		background-color: rgba(233, 235, 239, 0.6);
		border-radius: 3px;
		transition: all 0.3s ease;
		margin-right: 10px;
		position: relative;
		svg {
			width: 12px;
			height: 12px;
		}
		> span {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	&__title {
		align-items: center;
		display: flex;
		color: $colorPrimary;
		font-size: 16px;
		line-height: 18px;
		a {
			color: $colorPrimary7;
			text-decoration: underline;
		}
	}
	&--cart {
		.checkbox__title {
			color: $colorGrey8;
			font-size: 16px;
			line-height: 18px;
		}
	}
	&--cart.checkbox--disabled {
		.checkbox__title {
			color: $colorPrimary5;
			font-size: 16px;
			line-height: 18px;
		}
	}

	&--lightTheme {
		.checkbox__box {
			background-color: $colorWhite;
		}
	}
	&--small {
		.checkbox__title {
			display: inline-block;
			color: $colorPrimary7;
			font-size: 13px;
			line-height: 18px;
		}
	}
}
</style>
